import axiosInstance from "./service-instance";

const getSupplyChainList = params => 
    axiosInstance.get("underwriting/supply-chain/list/", {
        params: {
            ...params,
            paginate: true,
            page_size: 20,
            page: 1
        }
    }).then(_ => ({
        data: _.data && _.data.results ? _.data.results : [],
        error: null
    })).catch(() => ({ data:[], error: null}));

export default {
    getDistributorsList: (search) =>
        axiosInstance.get("underwriting/distributors/list/", {
            params: {
                search
            }
        }),
    createUnderwritingJob: ({
        distributor_name,
        gstin
    }) =>
        axiosInstance.post("underwriting/analysis-playground-request-elap/create/", {
            distributor_name,
            gstin
        }),
    getJobs: (page, page_size, filters) =>
        axiosInstance.get("underwriting/analysis-playground-request/list/", {
            params: {
                page,
                page_size,
                search: filters
            }
        }),
    getLedgerAnalysis: (
        uapr_id,
        page,
        page_size,
        minimum_vintage,
        minimum_limit
    ) =>
        axiosInstance.get("underwriting/ledger-analysis/list/", {
            params: {
                uapr_id,
                page,
                page_size,
                minimum_vintage,
                minimum_limit
            }
        }),
    getLedgerAnalysisSummary: (uapr_id, minimum_vintage, minimum_limit) =>
        axiosInstance.get(
            `underwriting/analysis-playground-request/${uapr_id}/summary/`,
            {
                params: {
                    minimum_vintage,
                    minimum_limit
                }
            }
        ),
    getSupplyChainListByGSTIN: gstin  => getSupplyChainList({ gstin }),
    getSupplyChainListByLedgerName: (seller, ledger) => getSupplyChainList({ seller, name: ledger }),
    getAggregateDistributorData: () =>
        axiosInstance.get("/underwriting/aggregate-distributor-data/"),
    
    getAggregateLedgerAnalysis: (minimum_limit, minimum_vintage, tenor) =>
        axiosInstance.get("/underwriting/aggregate-ledger-analysis/", {
            params: {
                minimum_vintage,
                minimum_limit,
                tenor
            }
        }),
    getDistributorData: (page, page_size, search) =>
        axiosInstance.get("/underwriting/distributor-data/", {
            params: {
                page,
                page_size,
                search
            }
        }),
    
    getAggregateLedgerData: (minimum_limit, minimum_vintage, tenor, page, page_size) =>
        axiosInstance.get("/underwriting/aggregate-distributor-ledger-data/", {
            params: {
                minimum_vintage,
                minimum_limit,
                tenor,
                page,
                page_size
            }
        }),
    getLedgerFile: (supply_chain_id, excel,is_payment_status = false, type) =>
        axiosInstance.post("/underwriting/aggregate-ledger-export/", {
            supply_chain_id,
            excel,
            type,
            is_payment_status
        }, {
            headers: {
                "Content-Type": "application/json"
            },
            responseType: "arraybuffer"
        })
};
